import React from 'react';

export type ActivityChipVariant = 'active' | 'recent' | 'inactive' | 'not-onboarded';

interface ActivityChipProps {
  variant: ActivityChipVariant;
  label?: string;
}

const VARIANT_STYLES: Record<ActivityChipVariant, string> = {
  active: 'bg-green-50 text-green-700 dark:bg-green-500/15 dark:text-green-400',
  recent: 'bg-teal-50 text-teal-700 dark:bg-teal-500/15 dark:text-teal-400',
  inactive: 'bg-surface-secondary text-on-surface-secondary',
  'not-onboarded': 'bg-yellow-50 text-yellow-800 dark:bg-yellow-500/15 dark:text-yellow-400',
};

const DEFAULT_LABELS: Record<ActivityChipVariant, string> = {
  active: 'Active',
  recent: 'Recent',
  inactive: 'Inactive',
  'not-onboarded': 'Not onboarded',
};

export function ActivityChip({ variant, label }: ActivityChipProps): React.ReactNode {
  return (
    <span
      className={`inline-flex items-center rounded px-8 py-2 text-[1.1rem] font-medium ${VARIANT_STYLES[variant]}`}
    >
      {label ?? DEFAULT_LABELS[variant]}
    </span>
  );
}
